var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-desc-link event-list"},[_c('ul',{class:_vm.eventContentList.length > 1 ? 'event-row02' : 'event-row01'},_vm._l((_vm.eventContentList),function(contentInfo,index){return _c('li',{key:index},[_c('EventContent',{attrs:{"content-info":contentInfo,"content-type":_vm.contentType}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }